<template>
	<div class="">
		<div class="banners">
			<div class="main-container">
				<div class="">
					<div class="sidebar" v-bind:class="{ 'close-sidebar': sidebarHide}">
						<Sidebar :settings="SideBarSettings" :key="refresh"/>
					</div>
					<div class="content">
						<div class="row">
							<div class="col">
								<router-view :key="$route.path" :sidecallback="sidebarCallback"/>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	// import Topbar from '../components/Topbar.vue';
	import Sidebar from '../components/Sidebar.vue';
	// import Popups from '../components/organisationPopups.vue';
	import { mapState, mapGetters, mapActions } from 'vuex';


	export default {
		data() {
			return {
				mainColor: '#00a0c1',
				SideBarSettings : {
					mainColor: '#00a0c1',
					sidebarTopColor: '',
					logo: '@/assets/img/logo.png', // 200x66
				},
				sidebarHide: false,
				TopBarSettings: {

				},
				refresh: Math.random()
			}
		},
		components: {
			Sidebar
			// Popups
		},

		computed: {
			...mapState('auth', ['user']),
			...mapGetters('auth', ['isAuthenticated', 'isOrgAdmin']),
			...mapGetters('organisation', ['selectedOrgId'])
		},
		watch:{
			$route (to, from){
				// if (this.$route.params.org_id == undefined) {
				// 	this.$swal({
				// 		title: "Unsable to find organisation. Please try again",
				// 		icon: "error"
				// 	});
				// 	this.$router.push({ path: "/dashboard" });
				// }

				this.refresh = Math.random();
			}
		},

		mounted() {
			// if (this.$route.params.org_id == undefined) { // string undefined coming from localStorage
			// 	this.$swal({
            //         title: "Unsable to find organisation. Please try again",
            //         icon: "error"
            //     });
			// 	this.$router.push({ path: "/dashboard" });
			// } else { // return will not stop the code reading
			// }
			this.init();
			this.refresh = Math.random();
		},

		created() {
			if (!this.isAuthenticated) {
                this.logout('Your session has expired. Please log in.');
				return;
            }

			if (this.isOrgAdmin && this.selectedOrgId && this.$route.path === '/') {
                this.$router.push(`/${this.selectedOrgId}/dashboard`);
            }

			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		},
		destroyed() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			...mapActions('auth', ['logout']),
			init() {
				// The user object is now passed via computed property from Vuex
				this.SideBarSettings.user = this.user;
				// this.refresh = Math.random();
			},

			closeSidebar() {
				if (this.sidebarHide) {
					this.sidebarHide = false;
				} else {
					this.sidebarHide = true;
				}
			},

			sidebarCallback(v) {
				if (v) {
					this.refresh = Math.random();
				}
			},

			handleResize() {
				if (window.innerWidth <= 1520) {
					this.sidebarHide = true;
				} else {
					this.sidebarHide = false;
				}
			}

		}
	}
</script>